import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Settings2 } from "lucide-react";
import { ApiAccessCard } from "@/components/ApiAccessCard";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { PurgeCard } from "@/components/PurgeCard";
import { TaxImpoundSettings } from "@/components/TaxImpoundSettings";
import { LegacyMigrationCard } from "@/components/LegacyMigrationCard";
import { UsersCard } from "@/components/UsersCard";
import { ImpersonationLog } from "@/components/ImpersonationLog";
import { TaxTables } from "@/components/TaxTables";
import { FailoverCard } from "@/components/FailoverCard";
import { RolesCard } from "@/components/RolesCard";
import { TileColorsCard } from "@/components/TileColorsCard";

const TABS = ["users", "roles", "tax", "platform", "branding", "api"];

export default function AdminSettings() {
  const [sp, setSp] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => { if (sp.get("tab") === "website") navigate("/marketing?tab=website", { replace: true }); }, [sp, navigate]);
  const tab = TABS.includes(sp.get("tab")) ? sp.get("tab") : "users";
  return (
    <div className="space-y-6 animate-fade-up max-w-5xl" data-testid="admin-settings-page">
      <div><h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2"><Settings2 className="w-7 h-7 text-primary" /> Admin Settings</h1><p className="text-sm text-muted-foreground mt-1">Users and access, tax configuration and platform maintenance. Website and sales collateral live under Growth → Marketing.</p></div>
      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })}>
        <TabsList data-testid="admin-settings-tabs">
          <TabsTrigger value="users" data-testid="tab-users">Users & access</TabsTrigger>
          <TabsTrigger value="roles" data-testid="tab-roles">Roles</TabsTrigger>
          <TabsTrigger value="tax" data-testid="tab-tax">Tax</TabsTrigger>
          <TabsTrigger value="platform" data-testid="tab-platform">Platform</TabsTrigger>
          <TabsTrigger value="branding" data-testid="tab-branding">Branding</TabsTrigger>
          <TabsTrigger value="api" data-testid="tab-api">API Access</TabsTrigger>
        </TabsList>
        <TabsContent value="api" className="mt-4 space-y-6"><ApiAccessCard /></TabsContent>
        <TabsContent value="branding" className="mt-4 space-y-6"><TileColorsCard /></TabsContent>
        <TabsContent value="users" className="mt-4 space-y-6"><UsersCard /><ImpersonationLog /></TabsContent>
        <TabsContent value="roles" className="mt-4 space-y-6"><RolesCard /></TabsContent>
        <TabsContent value="tax" className="mt-4 space-y-6"><TaxTables /><TaxImpoundSettings /></TabsContent>
        <TabsContent value="platform" className="mt-4 space-y-6"><FailoverCard /><LegacyMigrationCard /><PurgeCard /></TabsContent>
      </Tabs>
    </div>
  );
}
